import styled from 'styled-components';

export const MapIngredientModalContainer = styled.div`
  width: 100%;
  color: #a5e;
  display: flex;
  justify-content: center;
  height: auto;
`;
